<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection :text="(id) ? 'Editar meta' : 'Crear meta'" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Guardar" :cancelUrl="{ name: 'company.admin.goal.index' }" :submitting="submitting" :errors="validationExternal" @submit="submit" v-if="!loading">
				<template #body>
					<CommonFormInputText v-model="target.name" title="Nombre" placeholder="Ingrese un nombre" :validation="validation.name" />
					<CommonFormInputSelect v-model="target.currency" title="Moneda" placeholder="Seleccionar moneda" :options="$env.GENERAL.currencies" :validation="validation.currency" />
					<CommonFormInputSelect v-model="target.goal_field" title="Tipo de monto de venta para el cálculo de metas" placeholder="Seleccionar tipo de monto" :options="$env.MODEL.Goal.goal_fields" :validation="validation.goal_field" />
					<CommonFormInputSelect v-model="target.commission_field" title="Tipo de monto de venta para el cálculo de comisiones" placeholder="Seleccionar tipo de monto" :options="$env.MODEL.Goal.commission_fields" :validation="validation.commission_field" />
					<CommonFormInputCustomLevel v-model:levels="target.levels" title="Niveles y comisiones" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { reactive, onBeforeMount } from 'vue';
	import router from '@/router';
	import _ from 'lodash';
	import useVuelidate from '@vuelidate/core';
	import { required, minLength, maxLength } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import CompanyAdminGoalRepository from '@/repositories/modules/Company/Admin/Goal';

	export default {
		props: {
			id: String
		},
		setup(props) {
			const { loading, submitting, validationExternal, catchError } = composableForm();

			const target = reactive({
				id: null,
				name: null,
				currency: null,
				goal_field: null,
				commission_field: null,
				levels: []
			});

			const validation = useVuelidate({
				name: {
					required,
					minLength: minLength(3),
					maxLength: maxLength(150)
				},
				currency: {
					required
				},
				goal_field: {
					required
				},
				commission_field: {
					required
				}
			}, target);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;

				if(props.id != undefined) {
					await CompanyAdminGoalRepository.update(props.id, target).then(() => {
						router.push({ name: `company.admin.goal.index` });
					}).catch(catchError);
				}else{
					await CompanyAdminGoalRepository.store(target).then((response) => {
						router.push({ name: 'company.admin.goal.period.index', params: { id: response.data.id }});
					}).catch(catchError);
				}

				submitting.value = false;
			}

			onBeforeMount(async () => {
				if(props.id != undefined) {
					await CompanyAdminGoalRepository.show(props.id).then((response) => {
						Object.assign(target, response.data);
						if(target.levels == null) target.levels = [];
					}).catch((e) => {
						catchError(e);
						router.push({ name: `company.admin.goal.index` });
					});
				}else{
					await CompanyAdminGoalRepository.copy(props.id).then((response) => {
						Object.assign(target, response.data);
						if(target.levels == null) target.levels = [];
					}).catch((e) => {
						catchError(e);
						router.push({ name: `company.admin.goal.index` });
					});
				}

				loading.value = false;
			});

			return { loading, target, submit, submitting, validation, validationExternal };
		}
	}
</script>